<div class="desktop-iti-list">
    <ion-row class="ion-text-center">
        <ion-col size="2">
            <p class="iti-col-header ion-text-center">
                Dates
            </p>
        </ion-col>
        <ion-col size="2">
            <p class="iti-col-header ion-text-center ">
                Experience
            </p>
        </ion-col>
        <ion-col size="1">
            <p class="iti-col-header ion-text-center">
                Type
            </p>
        </ion-col>
        <ion-col size="2">
            <p class="iti-col-header ion-text-center">Location</p>
        </ion-col>
        <ion-col size="1">
            <p class="iti-col-header ion-text-center">
                Price
            </p>
        </ion-col>
        <ion-col size="1">
            <p class="iti-col-header ion-text-center">
                Next Step
            </p>
        </ion-col>
        <ion-col size="1"></ion-col>
    </ion-row>
    <ion-list>
        <ion-item
            class="iti-row"
            button
            details="false"
            *ngFor="let application of chainedApplications; let i = index"
            [ngClass]="{
                selected: application?.programid === selectedProgram
            }"
        >
            <app-application-chain-item
                [chainItem]="application"
                [index]="i"
                (click)="openProgramDetails(application.programid)"
            >
            </app-application-chain-item>
        </ion-item>
    </ion-list>
</div>
<div class="mobile-iti-list">
    <ion-list class="ion-no-margin">
        <ion-item
            class="iti-row iti-mobile-item ion-no-padding ion-no-margin"
            *ngFor="let application of chainedApplications; let i = index"
        >
            <app-application-chain-item-mobile
                [chainItem]="application"
                [index]="i"
                style="width: 100%;"
                (click)="openProgramDetails(application.programid)"
            ></app-application-chain-item-mobile>
        </ion-item>
    </ion-list>
</div>
